var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSharedGym(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.293,
    height: 25.774,
    viewBox: "0 0 21.293 25.774",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1042",
    "data-name": "Group 1042",
    transform: "matrix(0.454, -0.891, 0.891, 0.454, -2271.153, -332.38)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1039",
    "data-name": "Group 1039",
    transform: "translate(715 2183)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_1022",
    "data-name": "Rectangle 1022",
    transform: "translate(4.534 0.032)",
    fill: "none",
    stroke: "#005682",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("rect", {
    width: 3.499,
    height: 14.057,
    rx: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 0.75,
    width: 1.999,
    height: 12.557,
    rx: 0.25,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_1023",
    "data-name": "Rectangle 1023",
    transform: "translate(1.968 0.662)",
    fill: "none",
    stroke: "#005682",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("rect", {
    width: 3.499,
    height: 12.369,
    rx: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 0.75,
    width: 1.999,
    height: 10.869,
    rx: 0.25,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_1024",
    "data-name": "Rectangle 1024",
    transform: "translate(0 5.294)",
    fill: "none",
    stroke: "#005682",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("rect", {
    width: 2.901,
    height: 3.536,
    rx: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 0.75,
    width: 1.401,
    height: 2.036,
    rx: 0.25,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1040",
    "data-name": "Group 1040",
    transform: "translate(733.527 2183)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_1022-2",
    "data-name": "Rectangle 1022",
    transform: "translate(0 0.032)",
    fill: "none",
    stroke: "#005682",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("rect", {
    width: 3.499,
    height: 14.057,
    rx: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 0.75,
    width: 1.999,
    height: 12.557,
    rx: 0.25,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_1023-2",
    "data-name": "Rectangle 1023",
    transform: "translate(2.566 0.662)",
    fill: "none",
    stroke: "#005682",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("rect", {
    width: 3.499,
    height: 12.37,
    rx: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 0.75,
    width: 1.999,
    height: 10.87,
    rx: 0.25,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_1024-2",
    "data-name": "Rectangle 1024",
    transform: "translate(5.132 5.294)",
    fill: "none",
    stroke: "#005682",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("rect", {
    width: 2.901,
    height: 3.536,
    rx: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 0.75,
    width: 1.401,
    height: 2.036,
    rx: 0.25,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1041",
    "data-name": "Group 1041",
    transform: "translate(722.636 2188.294)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_528",
    "data-name": "Path 528",
    d: "M3156.541,17718.912h11.288",
    transform: "translate(-3156.541 -17718.912)",
    fill: "none",
    stroke: "#005682",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_529",
    "data-name": "Path 529",
    d: "M3156.541,17718.912h11.288",
    transform: "translate(-3156.541 -17715.604)",
    fill: "none",
    stroke: "#005682",
    strokeWidth: 1.5
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSharedGym);
export default __webpack_public_path__ + "static/media/shared-gym.7e83d1883300492c56434b59bec4cf1a.svg";
export { ForwardRef as ReactComponent };